import { ChevronLeft } from 'lucide-react';
import { cn } from '@/lib/utils';
import { STRINGS } from '@/strings/strings';
import type { SeriesEpisodeContext } from '@/features/series/useSeriesEpisodeContext';

interface Props {
  ctx: SeriesEpisodeContext;
  /** KP renders white-on-navy; pass a white tint there. */
  dark?: boolean;
}

/**
 * Series-episode breadcrumb shown at the top of the story output page:
 * "<Season Title> · Folge n von total" + a back affordance to the season
 * overview. Also surfaces a "Staffelfinale" marker on the last episode.
 */
export function SeriesEpisodeBreadcrumb({ ctx, dark }: Props) {
  const S = STRINGS.series.output;
  const text = dark ? 'text-dream-white' : 'text-dream-navy';
  const subtext = dark ? 'text-dream-white/70' : 'text-dream-navy/70';

  return (
    <div className="mb-4 flex flex-col gap-1">
      <button
        type="button"
        onClick={ctx.onToSeason}
        className={cn('flex items-center gap-1 text-sm font-medium', subtext)}
      >
        <ChevronLeft aria-hidden className="h-4 w-4" />
        {S.backToSeason}
      </button>
      <p className={cn('text-xs font-semibold', text)}>
        {S.breadcrumb
          .replace('{title}', ctx.seasonTitle)
          .replace('{n}', String(ctx.episodeNumber))
          .replace('{total}', String(ctx.total))}
      </p>
      {ctx.isLast && <span className={cn('text-xs font-medium', subtext)}>{S.finaleMarker}</span>}
    </div>
  );
}
